module.exports = __webpack_public_path__ + "img/badge-communication-gold-darkbg.429e85fa.svg";